import React from 'react'
import {
  Container,
  Header,
  Table,
  Checkbox,
  Button,
  Segment,
  Icon,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import Selector from './Selector.js'

const Selections = ({mode, selections, currentSelectionName, onPickSelection}) => (
    <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
      <Header as='h1' style={{color: '#f2711c'}}>Selections</Header>
      <p>
        A selection holds a subset of curriculum items (topics and objectives).
        You can create as many selections as you want.
        For example, you might want to create a separate selection
        for each course you try to map.
      </p>
      {
        selections.length
        ?
          <div>
            <Table selectable basic='very'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell collapsing>
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    ID
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    Name
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    Author
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    Type
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing textAlign='right'>
                    Items
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  selections.map(selection=>(
                    <Table.Row
                      key={selection.id}
                      warning={selection.id===currentSelectionName}
                      onClick={()=>onPickSelection(selection.id)}
                    >
                      <Table.Cell style={{paddingLeft: '4px'}}>
                        <Checkbox radio onChange={()=>onPickSelection(selection.id)} checked={selection.id===currentSelectionName}/>
                      </Table.Cell>
                      <Table.Cell>
                        <Link to={'/selection/'+selection.id}>{selection.id}</Link>
                      </Table.Cell>
                      <Table.Cell>
                        <Link to={'/selection/'+selection.id}>{selection.name}</Link>
                      </Table.Cell>
                      <Table.Cell>{selection.author}</Table.Cell>
                      <Table.Cell>
                        <Selector
                          type={selection.type}
                          colorAll={true}
                          onToggleItem={(eid,cid)=>{console.log("toggle", eid, cid)}}
                        />
                      </Table.Cell>
                      <Table.Cell textAlign='right'>{Object.keys(selection.items).length}</Table.Cell>
                      <Table.Cell>
                        <Button compact icon='settings' color='orange' as={Link} to={'/selection/'+selection.id+'/settings'}/>
                      </Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
            </Table>
            <Button color='orange' as={Link} to='/new-selection'>Create New Selection</Button>
            <Button as={Link} to='/request-selection'>Request from Others</Button>
            <Button as={Link} to='/import-selection-via-paste'>Import</Button>
          </div>
        :
          <Segment placeholder>
            <Header icon>
              <Icon name='check'/>
              You don't have any selections.
            </Header>
            <Segment.Inline>
              <Button color='orange' as={Link} to='/new-selection'>Create New Selection</Button>
              <Button as={Link} to='/request-selection'>Request from Others</Button>
              <Button as={Link} to='/import-selection-via-paste'>Import</Button>
            </Segment.Inline>
          </Segment>
      }
    </Container>
)

export default Selections